/* eslint-disable jsx-a11y/alt-text */
import { masks, mask4, cardiver } from "../assets";

const Cardoverlay1 = params => {

  return (
    <>
      <div  className="modal fade" id="cardOverlay1" tabIndex="-1" aria-labelledby="cardOverlayModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header hide">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span className="close-btn" aria-hidden="true">
                      &times;
                  </span>
              </button>
            </div>

            <div className="modal-body padding-0">

                <div className="backcardlay">
                      <div className="container overlay-1">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                          <div className="card overlay-card-1 ">
                            <header className="overlay-1-header">
                              <h5 className="line-height memphis-mediums">
                                After being taunted about his clothes, your kid gets into a
                                fight and breaks another kid's glasses.The parent wants $200 to
                                pay for new glasses.
                              </h5>
                            </header>
                            <div className="col-md-12">
                              <h5 className="w-set-check mt-2 memphis-medium">You...</h5>
                              <label className="container w-checkox memphis-medium color-mistake-pay">
                                Refuse to pay for the glasses; you can't afford it.
                                <span className="yellows-texts m-auto Pacifico-Regulars">
                                  {" "}
                                  lose <img src={mask4} className="width-ovwelay-image" />{" "}
                                  home/family
                                </span>
                                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 1, 2)} type="radio" />
                                <span className="checkmark"></span>
                              </label>
                              <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
                              <label className="container w-checkox memphis-medium color-mistake-pay">
                                Pay $200 for the glasses and make your kid apologize.{" "}
                                <span className="brown-texts m-auto Pacifico-Regulars">
                                  lose <img src={cardiver} className="width-ovwelay-image" />{" "}
                                  money/debt
                                </span>
                                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 1, 3)} type="radio" />
                                <span className="checkmark"></span>
                              </label>
                              <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
                              <label className="container w-checkox memphis-medium color-mistake-pay">
                                Work out a plan for your kid to do chores and pay for the
                                glasses over time.
                                <span className="yellow-texts m-auto Pacifico-Regulars">
                                  {" "}
                                  lose <img src={masks} className="width-ovwelay-image" />{" "}
                                  time/energy
                                </span>
                                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 1, 1)} type="radio" />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                            <div className="col-md-12 text-right mt-4">
                              <h6 className="health-overlay-color font-economy memphis-medium">&copy;<span className="ml-1">Health Economy 2019</span></h6>
                            </div>
                          </div>
                          <div className="mt-4">
                            <div className="card-overlay-2 bg-overlay">
                              <div className="text-center">
                                <button onClick={(e) => params.keepOpen(e.target, 1)} type="text" className="overlay-button">
                                  Keep Open
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cardoverlay1;
